import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import BackDrop from "../../../components/ui/BackDrop";
import { cn } from "../../../utils/twMerge";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

import { datePickerIcon, closeIcon } from "../../../assetData/icons";

const MasterPriceHeader = ({ setFilter, filterStatus , onFilterChange, setBankData, setStatusFilter}) => {
  const schema = z.object({
    role_name: z.string().nonempty(),
    status: z.boolean().or(z.string()),
    eff_start_date: z.string().nonempty(),
    eff_end_date: z.string().nonempty(),
  });

  const form = useForm({
    defaultValues: {
      status: "true",
      short_name: "-",
    },
    resolver: zodResolver(schema),
  });

  const errors = form.formState.errors;

  const [selected, setSelected] = useState("");
  const [byDefault, setByDefault] = useState("Select Status");

  const handleFilter = (e) => {
    onFilterChange(e.target.value);
  };

  // const updateFilter = () => {
  //   const filterData = filterStatus();
  //   setBankData(filterData);
  // };
  // useEffect(()=>{
  //   setStatusFilter(filterData);
  // })

  // const clearFilter = () => {
  //   setFilter("");
  //   window.location.reload();
  //   var dropDown = document.getElementById("ddlFruits");
  //   dropDown.selectedIndex = 0;
  // };

  return (
    <div className="mb-6 flex  justify-between gap-2">
      <div className=" flex  gap-4 text-neutral-600">
        <div className="flex w-[200px]  flex-col gap-2 ">
          <label>Status</label>

          <select
            id="ddlFruits"
            onChange={(e) => setStatusFilter(e.target.value)}
            className={cn(
              "hide-calendar-picker h-full w-full rounded bg-neutral-100 p-2 px-2 text-[#636363] focus:outline-none",
            )}
          >
            <option value="">{byDefault}</option>
            <option value={"Active"}>Active</option>
            <option value={"Inactive"}>Inactive</option>
          </select>
        </div>
      </div>

      <div className="flex gap-[70px]">
        {/* <button
          className="mt-auto w-[165px] rounded bg-[#F2673A] px-4 py-[.4rem] text-white"
          onClick={() => clearFilter()}
        >
          Clear
        </button>
        <button
          className="mt-auto w-[185px] rounded bg-[#F2673A] px-4 py-[.4rem] text-white"
          onClick={() => updateFilter()}
        >
          Submit
        </button> */}
      </div>
    </div>
  );
};

export default MasterPriceHeader;
